module.exports = __webpack_public_path__ + "img/Pic_Title_Line.14206e65.png";